import AirCarrier from './AirCarrier';

export default AirCarrier;
